import { NavLink } from './NavLink';

export const DesktopNav = () => {
  return (
    <nav className="hidden md:flex items-center gap-8">
      <NavLink to="/">Home</NavLink>
      <NavLink to="/shop">Shop</NavLink>
      <NavLink to="/downloads">Downloads</NavLink>
      <NavLink to="/about">About</NavLink>
    </nav>
  );
};
